module.exports = {

  getGeoIp: function (ip) {
    return this.client.get(`/v${this.v}/geoip/`, { params: { ip }})
  },

}



// WEBPACK FOOTER //
// ./shared/mapmy/geoip.js